import { ArrowDown, ArrowUp, Plus } from 'lucide-react'
import {
  computeAdjustments,
  formatMinutesDiff,
} from '../constants/hrmsRegularizationReview.constants'
import type { AttendanceSource } from '../types/hrmsAttendanceRecords.types'
import { AttendanceComparisonCard } from './AttendanceComparisonCard'

interface AttendanceComparisonProps {
  currentCheckIn?: string
  currentCheckOut?: string
  requestedCheckIn?: string
  requestedCheckOut?: string
  currentSource?: AttendanceSource
}

export function AttendanceComparison({
  currentCheckIn,
  currentCheckOut,
  requestedCheckIn,
  requestedCheckOut,
  currentSource,
}: AttendanceComparisonProps) {
  const adjustments = computeAdjustments(
    currentCheckIn,
    currentCheckOut,
    requestedCheckIn,
    requestedCheckOut
  )

  return (
    <div className="space-y-3 min-w-0">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 min-w-0">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
          ATTENDANCE COMPARISON
        </span>

        <div className="flex items-center gap-2 flex-wrap">
          {adjustments.map((adj, index) => {
            if (adj.kind === 'earlier') {
              return (
                <span
                  key={index}
                  className="bg-emerald-50 text-emerald-700 border border-emerald-200 text-xs font-semibold px-2.5 py-1 rounded-full inline-flex items-center gap-1"
                >
                  <ArrowUp className="h-3 w-3 text-emerald-600 shrink-0" />
                  {adj.field} adjusted {formatMinutesDiff(adj.minutes || 0)} earlier
                </span>
              )
            }
            if (adj.kind === 'later') {
              return (
                <span
                  key={index}
                  className="bg-amber-50 text-amber-700 border border-amber-200 text-xs font-semibold px-2.5 py-1 rounded-full inline-flex items-center gap-1"
                >
                  <ArrowDown className="h-3 w-3 text-amber-600 shrink-0" />
                  {adj.field} adjusted {formatMinutesDiff(adj.minutes || 0)} later
                </span>
              )
            }
            if (adj.kind === 'added') {
              return (
                <span
                  key={index}
                  className="bg-teal-50 text-teal-800 border border-teal-200 text-xs font-semibold px-2.5 py-1 rounded-full inline-flex items-center gap-1"
                >
                  <Plus className="h-3 w-3 text-teal-600 shrink-0" />
                  {adj.field} added
                </span>
              )
            }
            return null
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 min-w-0">
        <AttendanceComparisonCard
          variant="current"
          checkIn={currentCheckIn}
          checkOut={currentCheckOut}
          source={currentSource}
        />
        <AttendanceComparisonCard
          variant="requested"
          checkIn={requestedCheckIn}
          checkOut={requestedCheckOut}
          oldCheckIn={currentCheckIn}
          oldCheckOut={currentCheckOut}
        />
      </div>
    </div>
  )
}
